import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonDirective } from '../../directives/button.directive';

@Component({
  selector: 'app-form-load-error',
  standalone: true,
  imports: [TranslocoDirective, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *transloco="let t" role="alert" class="alert-blocked flex items-center content-gap px-3 py-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        />
      </svg>
      <span>{{ message() }}</span>
      <button appButton="secondary" type="button" (click)="retry.emit()">
        {{ t('common.tryAgain') }}
      </button>
    </div>
  `,
})
export class FormLoadErrorComponent {
  public readonly message = input.required<string>();

  public readonly retry = output<void>();
}
